import { Component, signal, HostListener } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { AppService } from '@app/app.service';
import { AuthService } from '@app/auth/auth.service';
import { RouterModule } from '@angular/router';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { User, UserCarrier } from '@app/auth/user.model';
import { MatIconModule } from "@angular/material/icon";
import { EditConnectionDialogComponent } from '@app/account/edit-connection-dialog/edit-connection-dialog.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-connections',
  standalone: true,
  imports: [
    MatTooltipModule,
    RouterModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIconModule
],
  templateUrl: './connections.component.html',
  styleUrl: './connections.component.scss',
})
export class ConnectionsComponent {
  loading = signal(false);

  connections: any[] = [];
  carriers: UserCarrier[] = [];
  user: User | null = null;

  activeCarrierConnection = signal(false);
  activeBrokerConnection = signal(false);

  isMobile = window.innerWidth < 768;

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth < 768;
  }

  constructor(
    private appService: AppService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getUserConnections();
    this.setUser();
  }

  getUserConnections() {
    this.appService.get('user/carrier-connections').subscribe({
      next: (success) => {
        this.connections = success.data;
        this.carriers = this.connections.map((connection: any) => connection.carrier);

        this.getConnectionStatuses();
      },
      error: (error) => {
        this.connections = [];
        this.carriers = [];
        this.appService.handleError(error);
      }
    });
  }

  deleteConnection(connection: any) {
    const question = `Are you sure you want to leave ${connection.carrier.legal_name}?`;

    this.appService.confirm(question).subscribe(result => {
      if (!result) {
        return;
      }

      this.authService.deleteMyConnection(connection.dot_number).subscribe({
        next: (success) => {
          this.appService.showSnackBar(success.message, 'success');

          this.connections = this.connections.filter(
            c => c.dot_number !== connection.dot_number
          );

          this.carriers = this.connections.map(c => c.carrier);

          this.getConnectionStatuses();
          this.setUser();
        },
        error: (error) => {
          this.appService.handleError(error);
        },
      });
    });
  }

  setUser() {
    this.authService.getUser().subscribe({
      next: (success) => {
        if (success.data) {
          this.authService.setUserToStorage(success.data);
          this.appService.triggerHeaderRefresh();

          this.user = success.data;
          this.carriers = this.user?.carriers || [];
          this.getConnectionStatuses();
        }
      },
      error: (error) => {
        this.appService.handleError(error);
      },
    });
  }

  getConnectionStatuses() {
    this.activeCarrierConnection.set(false);
    this.activeBrokerConnection.set(false);

    this.carriers.forEach((carrier) => {

      if (carrier.allowed_to_operate !== 'Y') {
        return;
      }

      if (
        carrier.carrier_common_authority_status === 'A' ||
        carrier.carrier_contract_authority_status === 'A'
      ) {
        this.activeCarrierConnection.set(true);
      }

      if (carrier.broker_authority_status === 'A') {
        this.activeBrokerConnection.set(true);
      }
    });

  }

  getCarrierType(carrier: any): string {
    const isCarrier =
      carrier.allowed_to_operate === 'Y' &&
      (
        carrier.carrier_common_authority_status === 'A' ||
        carrier.carrier_contract_authority_status === 'A'
      );

    const isBroker =
      carrier.allowed_to_operate === 'Y' &&
      carrier.broker_authority_status === 'A';

    if (isBroker && isCarrier) {
      return 'BROKER & CARRIER';
    }

    if (isBroker) {
      return 'BROKER';
    }

    if (isCarrier) {
      return 'CARRIER';
    }

    return '';
  }

  updateConnection(connection: any) {
    this.dialog.open(EditConnectionDialogComponent, {
      width: '400px',
      data: {
        connection,
      },
    }).afterClosed().subscribe((updated) => {
      if (updated) {
        this.getUserConnections();
        this.setUser();
      }
    });
  }

}